import React from 'react';
import KitchenHelperApp from './KitchenHelperApp'; // adjust path if your file is elsewhere

function App() {
  return <KitchenHelperApp />;
}

export default App;
